<template>
  <div class="parent_cast_cont_">
    <div
      class="room_header flex justify-between items-center w-full h-16 px-4 py-2 z-5 sticky top-0"
    >
      <p class="text-xl font-bold">/room.details</p>
    </div>

    <div class="flex flex-col gap-4 text-lg pt-6">
      <h1 class="text-xl font-bold" style="color: #545454 !important">
        C:\{{ activeUserInfo.firstName }}\room.name &gt;
        <span style="color: #22c55e !important">{{
          selectedRoomDetails && selectedRoomDetails.room_name
        }}</span>
      </h1>
      <p class="basic_detail_cont_">
        &gt;&gt; Room Type &gt;
        <span class="text-white">{{
          selectedRoomDetails && selectedRoomDetails.type
        }}</span>
      </p>
    </div>

    <SessionsList :meeting-id="meetingSlug" @play-recording="onPlayRecording" />
  </div>
</template>

<script>
import SessionsList from '@/views/new-dashboard/components/SessionsList.vue';

export default {
  name: 'RoomDetails',
  components: { SessionsList },
  props: ['selectedRoomDetails', 'firstRoomId'],
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    meetingSlug() {
      const room = this.selectedRoomDetails;
      if (!room) return '';
      if (room.public_meeting_id) return room.public_meeting_id;
      if (room.room_url) {
        const parts = String(room.room_url).split('/');
        return parts[parts.length - 1] || '';
      }
      return '';
    },
  },
  mounted() {
    if (this.firstRoomId && !this.selectedRoomDetails) {
      this.selectedRoomDetails = this.firstRoomId;
    }
  },
  methods: {
    onPlayRecording(recording) {
      this.$emit('play-recording', recording);
    },
  },
};
</script>

<style scoped>
.room_header {
  background-color: #272727;
}

.basic_detail_cont_ {
  color: #545454;
}
</style>
